import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatFormFieldModule} from "@angular/material/form-field";
import {provideNativeDateAdapter} from "@angular/material/core";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {OverlayModule} from "@angular/cdk/overlay";
import {MatPaginator, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {PatientsFilterService} from "../../../services/patients/patient-filter.service";

/** Controls for the organizations list page. This contains controlling search, provider, and date filters */
@Component({
	selector: 'app-patients-filter',
	imports: [
		MatInputModule,
		MatButtonModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		OverlayModule,
		MatPaginatorModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './patients-controls.component.html',
	styleUrl: './patients-controls.component.scss'
})
export class PatientsControls implements OnInit {

	/** global search */
	globalSearch:FormControl<string>;

	/** The search control on the page */
	searchControl = new FormControl<string>('');

	/** Dispatched when the search filter changes */
	@Output()
	readonly searchChange = new EventEmitter<string>();

	@ViewChild(MatPaginator)
	private paginator:MatPaginator;

	constructor(private patientsFilterService:PatientsFilterService) {
	}

	ngOnInit():void {

		this.globalSearch = new FormControl<string>('');

		this.searchControl.valueChanges.subscribe(value => this.searchChange.emit(value));
	}

	onPageChange(event:PageEvent) {
		this.patientsFilterService.pageEvent = event;
	}

	setTotal(total:number) {
		this.paginator.length = total;
	}

	async onEnterKey() {
		if(!this.globalSearch.getRawValue()) {
			this.patientsFilterService.globalSearch = this.globalSearch.getRawValue();
		}
	}

	async clickGlobalSearchX(event:MouseEvent) {
		if((event as PointerEvent).pointerId > 0) {
			this.globalSearch.reset(null);
			this.patientsFilterService.globalSearch = this.globalSearch.getRawValue();
		} else {
			this.patientsFilterService.globalSearch = this.globalSearch.getRawValue();
		}
	}
}
